import { render, staticRenderFns } from "./NovaTabItem.vue?vue&type=template&id=3a328094&lang=pug&"
import script from "./NovaTabItem.vue?vue&type=script&lang=js&"
export * from "./NovaTabItem.vue?vue&type=script&lang=js&"
import style0 from "./NovaTabItem.vue?vue&type=style&index=0&id=3a328094&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports